export default __webpack_public_path__ + "static/media/photo-1541271696563-3be2f555fc4e.24ecd158.jpeg";